<h1 mat-dialog-title>{{ "editTimes" | i18n }}</h1>
<div
  mat-dialog-content
  (keydown.enter)="save()">
  <div
    *ngFor="let time of times; let i = index"
    class="row">
    <div class="col">
      <p>{{ "shifts." + time.shift | i18n }}</p>
    </div>
    <div class="col">
      <mat-form-field
        [class.ng-invalid]="fromInvalid"
        class="light-form-field">
        <mat-label>{{ "shiftStart" | i18n }}</mat-label>
        <input
          matInput
          type="time"
          name="from"
          [(ngModel)]="time.from"
          (ngModelChange)="validateTimes()"
          required
          placeholder="from"
          data-cy="partial-accept-from-input" />
      </mat-form-field>
    </div>
    <div class="col">
      <mat-form-field
        [class.ng-invalid]="toInvalid"
        class="light-form-field">
        <mat-label>{{ "shiftEnd" | i18n }}</mat-label>
        <input
          matInput
          type="time"
          name="to"
          [(ngModel)]="time.to"
          (ngModelChange)="validateTimes()"
          required
          placeholder="to"
          data-cy="partial-accept-to-input" />
      </mat-form-field>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    mat-button
    (click)="save($event)"
    style="margin: 0 auto"
    data-cy="partial-accept-save-button">
    {{ ("save" | i18n) || "save" | uppercase }}
  </button>
</div>
